/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";

import { Rule } from "../../../models/rule";
import { RuleCondition } from "../../../models/rule-condition";

@Component({
  selector: 'app-time-parameter-editor',
  templateUrl: './time-parameter-editor.component.html'
})
export class TimeParameterEditorComponent implements OnInit {

    @Input()
    rule: Rule;

    @Input()
    ruleCondition: RuleCondition;
    
    showBody: boolean = true;
    
    ngOnInit(): void {

    }
    
    onRemove(): void {
        const index = this.rule.conditions.indexOf(this.ruleCondition);
        
        if (index > -1) {
            this.rule.conditions.splice(index, 1);
        }
    }

}
